import axios from './axios'
import socket from './socket'
import md5 from 'js-md5';
import Croppa from 'vue-croppa';
import {
  Button,
  Select,
  Cascader,
  Input,
  Form,
  FormItem,
  Checkbox,
  Menu,
  Submenu,
  MenuItem,
  Dialog,
  Tree,
  Pagination,
  InputNumber,
  Tabs,
  TabPane,
  Tag,
  Message,
  Loading,
  Progress,
  Popover,
  RadioGroup,
  Radio,
  RadioButton,
  Card,
  Row,
  TimePicker,
  DatePicker,
  Collapse,
  CollapseItem,
  Option,
  OptionGroup,
  MessageBox,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Slider,
  Table,
  Steps,
  Upload,
  Switch,
  Scrollbar,
  Step,
  TableColumn,
  Col,
  CheckboxGroup,
  Autocomplete,
  Notification,
  Alert
} from 'element-ui';

export default {
  install: (Vue, options) => {
    Vue.prototype.$https = axios
    Vue.prototype.$socket = socket
    Vue.prototype.$md5 = md5;
    Vue.component(Tag.name, Tag);
    Vue.component(Button.name, Button);
    Vue.component(Select.name, Select);
    Vue.component(Cascader.name, Cascader);
    Vue.component(Input.name, Input);
    Vue.component(Form.name, Form);
    Vue.component(FormItem.name, FormItem);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(Menu.name, Menu);
    Vue.component(Submenu.name, Submenu);
    Vue.component(MenuItem.name, MenuItem);
    Vue.component(Dialog.name, Dialog);
    Vue.component(Tree.name, Tree);
    Vue.component(Pagination.name, Pagination);
    Vue.component(Breadcrumb.name, Breadcrumb);
    Vue.component(Tabs.name, Tabs);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Progress.name, Progress);
    Vue.component(Popover.name, Popover);
    Vue.component(RadioGroup.name, RadioGroup);
    Vue.component(Radio.name, Radio);
    Vue.component(Row.name, Row);
    Vue.component(Col.name, Col);
    Vue.component(TimePicker.name, TimePicker);
    Vue.component(DatePicker.name, DatePicker);
    Vue.component(Option.name, Option);
    Vue.component(OptionGroup.name, OptionGroup);
    Vue.component(Tooltip.name, Tooltip);
    Vue.component(Slider.name, Slider);
    Vue.component(Table.name, Table);
    Vue.component(TableColumn.name, TableColumn);
    Vue.component(Col.name, Col);
    Vue.component(BreadcrumbItem.name, BreadcrumbItem);
    Vue.component(CheckboxGroup.name, CheckboxGroup);
    Vue.component(Autocomplete.name, Autocomplete);
    Vue.component(Steps.name, Steps);
    Vue.component(Step.name, Step);
    Vue.component(Upload.name, Upload);
    Vue.component(Card.name, Card);
    Vue.component(Collapse.name, Collapse);
    Vue.component(CollapseItem.name, CollapseItem);
    Vue.component(InputNumber.name, InputNumber);
    Vue.component(RadioButton.name, RadioButton);
    Vue.component(Switch.name, Switch);
    Vue.component(Scrollbar.name, Scrollbar);
    Vue.component(Alert.name, Alert);


    Vue.prototype.$message = Message;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$loading = Loading.service;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$msgbox = MessageBox;
    Vue.use(Loading.directive);
    Vue.use(Croppa);
  }
}



// WEBPACK FOOTER //
// ./src/plugins/inject.js